
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesLadder = View.LeaguesLadder.extend({
		template: JST.TippingLeaguesLadder,
		ui:     {
			league_select: '.js-league-select',
			round_select:  '.js-round-select',
			sort_th:       '.js-sort-th',
			show_more:     '.js-load-more'
		},
		events: {
			'change @ui.league_select': 'changeLeague',
			'change @ui.round_select':  'changeRound',
			'click @ui.sort_th':        'sortTable',
			'click @ui.show_more':      'showMoreUsers'
		},
		initialize: function() {

			this.scrollToTop().
				showPreloader();

			this.league_id = this.getOption('league_id');
			this.league    = this.getOption('league');
			this.ladder    = this.getOption('ladder');
			this.leagues   = this.getOption('leagues');
			this.rounds    = this.getOption('rounds');
			this.user      = this.getOption('user');
			this.offset    = 0;
			this.limit     = 50;
			this.sort_order = 'rank';
			this.sort_direction = 'ASC';
			this.sort_field = '';

			this.fetchData();


		},

		fetchData() {
			var complete = [
				this.league.show().fetch({ data: { id: this.league_id } }),
				this.leagues.show_my().fetch(),
				this.rounds.fetch({ cache: true, expires: 60 })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));

			return this;
		},

		initTemplate: function() {
			if (this.initData().isCanAccess()) {
				this.trigger('leagues:view:menu', this.league);
				return this.initLadderData();
			}

			return this;
		},

		initData: function() {

			this.league.setCommissioner(this.user.get('id'));
			this.leagues = this.leagues.byStatus('scheduled', true);

			this.setAvailableRounds();

			return this;
		},

		setAvailableRounds() {
			const available_rounds = this.rounds.getPlayedRoundsOptions();
			if (available_rounds.length) {
				const league_rounds = this.league.getAvailableRounds(_.last(available_rounds).val);

				this.available_rounds = _.filter(available_rounds, function(round) {
					return _.include(league_rounds, round.value || round.val);
				});
	
				const last_round = _.last(this.available_rounds);
				const is_round_zero_exist = _.first(available_rounds).val === 0;
				const is_round_zero_active =  is_round_zero_exist && this.round_id ===0;
				const is_round_empty = !is_round_zero_exist && !this.round_id;
				if (last_round && is_round_empty || (!this.round_id && !is_round_zero_active)) {
					last_round.selected = true;
					this.round_id = last_round.val;
				}
			}

		},

		initLadderData: function() {
			var data = { id: this.league_id, round: this.round_id, type: 'overall', offset: this.offset, limit: this.limit};

			this.ladder
				.league_ladder()
				.fetch({data: data})
				.then(_.bind(this.checkResponseLength, this))
				.then(_.bind(this.updateLadder, this));

			return this;
		},

		setModelData: function() {

			this.model.set({
				round_id    : this.round_id,
				league      : this.league.toJSON(),
				leagues     : this.leagues.toJSON(),
				ladder      : this.ladder.get('ladder'),
				rounds      : this.available_rounds,
				sort_key    : this.ladder.sort_key,
				sort_order  : this.ladder.sort_order,
				avatars_url : CONFIG.AVATARS_URL,
				show_more   : this.show_more_status
			});

			return this;
		},

		changeRound: function() {
			this.round_id = +this.ui.round_select.val();
	
			var data = { id: this.league_id, round: this.round_id, type: 'overall', offset: this.offset, limit: this.limit};

			this.ladder
				.league_ladder()
				.fetch({data: data})
				.then(_.bind(this.checkResponseLength, this))
				.then(_.bind(this.updateLadder, this));


			return this;
		},

		updateLadder: function() {

			this.updateData()
				.setModelData()
				.render()
				.hidePreloader();

			return this;
		},

		updateData: function() {
			this.rounds.invoke('set', {"selected": false});
			const round = this.rounds.get(this.round_id);
			const is_round_zero_active = round && round.val === 0;
			if (round || is_round_zero_active) {
				round.set('selected', true)
			}


			this.setAvailableRounds();

			return this;
		},
		//
		// sortTable: function(e) {
		// 	var field = $(e.currentTarget).data('sort-field');
		// 	// console.log(this.ladder.sort_order);
		// 	this.ladder.sortLeagueLadder(field);
		//
		// 	return this.setModelData().render();
		// },

		sortTable: function(e) {
			this.showPreloader();

			var field = $(e.currentTarget).data('sort-field');
			this.sort_direction = this.getSortDirection(field);
			this.sort_order = field;

			const data = this.getDataForSort();
			const method = this.options.store_id ? 'store_ladder' : 'league_ladder';

			this.ladder
				.pseudoSortLeagueLadder(this.sort_order)
				[method]()
				.fetch({data: data})
				.then(_.bind(this.checkResponseLength, this))
				.then(_.bind(this.updateLadder, this));

			return this;
		},

		getDataForSort() {

			return { id: this.league_id, round: this.round_id, type: 'overall', offset: 0, limit: 50, order: this.sort_order, order_direction: this.sort_direction };
		},

		getSortDirection: function(field){
			var direction = 'ASC';
			if(field !== this.sort_order){
				return 'ASC';
			}

			if( this.sort_direction  == 'ASC'){
				direction = 'DESC';
			}
			else{
				direction = 'ASC';
			}

			return direction;
		},

		showMoreUsers: function(){

			this.showPreloader();

			var data = {
				id:      this.league_id,
				round:           this.round_id,
				type:            'overall',
				offset:          this.ladder.get('ladder').length,
				limit:           this.limit,
				order:           this.sort_order,
				order_direction: this.sort_direction
			};

			this.ladder
				.league_ladder()
				.fetch({data: data})
				.then(_.bind(this.checkResponseLength, this))
				.then(_.bind(_.partial(this.prependToLadder , this.ladder.get('ladder')), this))
				.then(_.bind(this.updateLadder, this));

			return this;
		},

		prependToLadder: function(ladder){

			this.ladder.set('ladder', ladder.concat(this.ladder.get('ladder')));

			return this;

		},

		checkResponseLength: function (response) {

			this.show_more_status = response.result.ladder.length >= this.limit;

			return this;

		}

	});

}(window, APP, Backbone, Marionette, $, _));